export const isIphone = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const iphoneRegex = /iphone/i;
  return iphoneRegex.test(userAgent);
};
